export default "__VITE_ASSET__vgok5t6a__"